import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import AdminTable from "../components/AdminTable";
import AdminForm from "../components/AdminForm";
import { createPaper, fetchPapers } from "../api/adminApi";
import { theme } from "../theme";
import { useToast } from "../context/ToastContext";
import Button from "../components/Button";

const Toolbar = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

const Loading = styled.p`
  color: ${theme.colors.textSecondary};
  font-family: ${theme.fonts.body};
`;

const PapersAdmin = () => {
  const navigate = useNavigate();
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formOpen, setFormOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  const columns = [{ Header: "Тип бумаги", accessor: "name" }];

  const fields = [
    {
      name: "name",
      label: "Тип бумаги",
      type: "text",
      required: true,
      placeholder: "Введите название",
    },
  ];

  const loadPapers = async () => {
    try {
      const data = await fetchPapers();
      setPapers(data);
    } catch (err) {
      console.error("Failed to load papers:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPapers();
  }, []);

  const handleSave = async (values) => {
    setSaving(true);
    try {
      const data = {
        name: values.name,
      };

      const newPaper = await createPaper(data);
      navigate(`/opredelitel/admin/papers/${newPaper.id}`);
      toast.success("Узор добавлен");

      setFormOpen(false);
      loadPapers();
    } catch (err) {
      toast.error("Ошибка сохранения");
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (block) => {
    navigate(`/opredelitel/admin/papers/${block.id}`);
  };

  const handleAdd = () => {
    setFormOpen(true);
  };

  if (loading) return <Loading>Загрузка...</Loading>;

  return (
    <div>
      <Toolbar>
        <Button $variant="success" onClick={handleAdd}>
          + Добавить
        </Button>
      </Toolbar>
      <AdminTable
        columns={columns}
        data={papers}
        onEdit={handleEdit}
        isReorderable={false}
      />
      <AdminForm
        isOpen={formOpen}
        onClose={() => setFormOpen(false)}
        onSave={handleSave}
        fields={fields}
        isLoading={saving}
      />
    </div>
  );
};

export default PapersAdmin;
